import React, { useState } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import Input from '../../TravellerContactInfo/FormFields/Input';
import { customStyles, UserFlowModalState } from '../../UserFlow/UserFlowModal';
import '../LoginModals.css';
import { If } from 'react-extras';

const initialStates = {
  showModal: true,
  validationFail: false,
};

const UserProfileIncomplete = (props: UserFlowModalState) => {
  const [ state, setState ] = useState(initialStates);

  const closeModal = () => {
    setState({
      ...state,
      showModal: false,
    });
    props.closeModal();
  };

  const goToIRCTCPage=() => {
    window.location.assign('https://www.irctc.co.in/nget/train-search');
  };

  const goToIRCTCRegistrationPage=() => {
    props.createAccount();
  };

  const { userStatus: { userId }, switchModal, allowClose } = props;
  const { validationFail, showModal } = state;
  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className="loginModals"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <p className="makeFlex spaceBetween appendBottom40">
        <span className="modalTitle font26 latoBloack blackText">
            IRCTC Profile Incomplete
        </span>
        <If condition={allowClose === true}>
          <span
            className="modalClose"
            onClick={closeModal}
          >
            X
          </span>
        </If>
      </p>
      <p className="vrtlSeperater" />
      <div className="makeFlex spaceBetween">
        <div className="leftPanel">
          <p className="font20 latoBold darkGreyText appendBottom10"> User verified but profile
              incomplete
          </p>
          <p className="font14 darkGreyText appendBottom40">
            <span className="redText"> Bookings are not allowed</span> by IRCTC for incomplete
              profiles.Please complete it on the IRCTC website to proceed with your booking.
          </p>
          <div className={`makeFlex spaceBetween ${validationFail ? 'hrtlCenter' : 'end'}`}>
            <Input
              labelName="IRCTC USERNAME"
              errorMessage={`Username ${userId} doesn’t exist.`}
              validationFail={validationFail}
              type="text"
              additionalAttributes={{ placeholder: userId }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg="Verified"
              vaidationMoreMsg="Change"
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly
              irctcUserId={userId}
              switchModal={switchModal}
              onChangePage="verifyUsername"
            />
          </div>
          <p className="darkGreyText lineHeight18 font14 appendTop30"><b>Note:</b> IRCTC Username
              is case sensitive, has 3-35 <br /> characters of upper and lower case letters
              , numbers and ‘_’.
          </p>
        </div>
        <div className="rightPanel">
          <p className="font20 latoBold darkGreyText appendBottom10">Complete your IRCTC
              profile
          </p>
          <p className="latoBold font14 greenText appendBottom15">and continue from where you
              left
          </p>
          <p className="font14 darkGreyText appendBottom20">Please visit IRCTC website to complete
              your profile and continue booking here.
          </p>
          <button
            className=" noShrink width220 appendBottom50"
            onClick={goToIRCTCPage}
          >
            <span className="font12 latoBlack capText">COMPLETE PROFILE</span>
          </button>
          <p className="font14 darkGreyText appendBottom5">Facing trouble?</p>
          <a className="font16 latoBold" onClick={goToIRCTCRegistrationPage}>Create New
              Account
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default withRouter(UserProfileIncomplete);
